module.exports = __webpack_public_path__ + "img/modeBtn_selected.f6947ac6.svg";